import { render, staticRenderFns } from "./SlideSelector.vue?vue&type=template&id=81ebffc0&"
import script from "./SlideSelector.vue?vue&type=script&lang=js&"
export * from "./SlideSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports